<nav mat-tab-nav-bar [tabPanel]="tabPanel" mat-stretch-tabs="false" mat-align-tabs="start">
  <a mat-tab-link routerLink="plan" #planActive="routerLinkActive" routerLinkActive
     [active]="planActive.isActive"> Subscription Plan </a>
  <a mat-tab-link routerLink="org-details" #orgDetailsActive="routerLinkActive" routerLinkActive
     [active]="orgDetailsActive.isActive"> Organisation Details </a>
</nav>
<mat-tab-nav-panel #tabPanel>
  <router-outlet></router-outlet>
</mat-tab-nav-panel>
